import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';

import { User } from '../../models';
import { ButtonModule } from '@openng/optimus-ui/button';
import { MenuModule } from '@openng/optimus-ui/menu';
import { MenuItem } from '@openng/optimus-ui/api';
import { Menu } from '@openng/optimus-ui/menu';

@Component({
  selector: 'app-user-dropdown',
  imports: [ButtonModule, MenuModule],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './user-dropdown.html',
  host: {
    '(document:click)': 'onDocumentClick($event)'
  }
})
export class UserDropdownComponent {
  @Input() user: User | null = null;
  @Output() profileClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();
  @ViewChild('menu') menu!: Menu;

  private readonly elementRef = inject(ElementRef);

  isOpen = false;
  menuItems: MenuItem[] = [
    {
      label: 'My Profile',
      icon: 'pi pi-user',
      command: () => this.onProfileClick()
    },
    {
      separator: true
    },
    {
      label: 'Sign Out',
      icon: 'pi pi-sign-out',
      command: () => this.onLogoutClick(),
      styleClass: 'text-red-500'
    }
  ];

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  toggle(event: Event): void {
    this.menu.toggle(event);
  }

  onProfileClick(): void {
    this.profileClick.emit();
    this.isOpen = false;
  }

  onLogoutClick(): void {
    this.logoutClick.emit();
    this.isOpen = false;
  }

  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  logout(): void {
    this.logoutClick.emit();
    this.isOpen = false;
  }

  getUserInitials(): string {
    if (!this.user?.fullName) return 'U';

    const names = this.user.fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }

    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  }
}
